import {
  isDepositSpendApproved,
  isWithdrawalSpendApproved,
} from "./display/approvals";
import { getBridgeFee } from "./display/bridge-fees";
import {
  getDepositExchangeRate,
  getWithdrawExchangeRate,
} from "./display/exchange-rate";

import type { BridgeTransactionData } from "./vaults/bridge";
import { prepareBridgeTransactionData } from "./vaults/bridge";

import type { ChainId } from "./api/vault-config";
import { getVaultByKey } from "./vaults";
import type { Vault, VaultKey } from "./vaults/config";
import { VaultKeys } from "./vaults/config";

import type {
  ApproveDepositTokenTransactionData,
  DepositAndBridgeTransactionData,
  DepositTransactionData,
} from "./vaults/deposit/deposit";
import {
  prepareApproveDepositToken,
  prepareDepositAndBridgeTransactionData,
  prepareDepositTransactionData,
} from "./vaults/deposit/deposit";

import type {
  ApproveWithdrawTokenTransactionData,
  BridgeAndWithdrawTransactionData,
  WithdrawTransactionData,
} from "./vaults/withdraw/withdraw";
import {
  prepareApproveWithdrawToken,
  prepareBridgeAndWithdrawTransactionData,
  prepareWithdrawTransactionData,
} from "./vaults/withdraw/withdraw";

export {
  getBridgeFee,
  getDepositExchangeRate,
  getVaultByKey,
  getWithdrawExchangeRate,
  isDepositSpendApproved,
  isWithdrawalSpendApproved,
  prepareApproveDepositToken,
  prepareApproveWithdrawToken,
  prepareBridgeAndWithdrawTransactionData,
  prepareBridgeTransactionData,
  prepareDepositAndBridgeTransactionData,
  prepareDepositTransactionData,
  prepareWithdrawTransactionData,
  VaultKeys,
};

export type {
  ApproveDepositTokenTransactionData,
  ApproveWithdrawTokenTransactionData,
  BridgeAndWithdrawTransactionData,
  BridgeTransactionData,
  ChainId,
  DepositAndBridgeTransactionData,
  DepositTransactionData,
  Vault,
  VaultKey,
  WithdrawTransactionData,
};
